import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from 'vue';
import { UploadedFile } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import FileUploader from './FileUploader.vue';
import InformationIcon from '../../../icons/components/InformationIcon.vue';
import LoadingOverlay from '../overlays/LoadingOverlay.vue';
import { format } from 'date-fns';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileReplacer',
  props: {
    title: null,
    uploaded: null,
    loading: { type: [Boolean, String], default: false },
    replaceButtonLabel: { default: 'Replace Document' },
    uploadButtonLabel: { default: 'Upload' }
  },
  setup(__props: any) {

const props = __props as { title: string, uploaded?: UploadedFile, loading: boolean | string, replaceButtonLabel: string, uploadButtonLabel: string };



const state = reactive<{
  fileSelected: File | null;
}>({
  fileSelected: null,
});

const fileUploader = ref<InstanceType<typeof FileUploader> | null>(null);

const uploadModal = ref<InstanceType<typeof BModal> | null>(null);

const loading = computed(() => fileUploader.value?.isLoading || props.loading);

const modalTitle = computed(() => {
  if (!props.uploaded) {
    return `Upload new ${props.title}`;
  }
  return `Replace the existing ${props.title} document`;
});

const buttonLabel = computed(() => (props.uploaded ? props.replaceButtonLabel : props.uploadButtonLabel));

function onFileSelected(file: File | null) {
  state.fileSelected = file;
}

function showModal() {
  uploadModal.value?.show();
}

function hideModal() {
  uploadModal.value?.hide();
}

function onFileUploaded() {
  hideModal();
}

function uploadFile() {
  fileUploader.value?.uploadFile(0);
}

return { __sfc: true,props, state, fileUploader, uploadModal, loading, modalTitle, buttonLabel, onFileSelected, showModal, hideModal, onFileUploaded, uploadFile, BModal, FileUploader, InformationIcon, LoadingOverlay, format }
}

})